module.exports = __webpack_public_path__ + "img/title_bg@3x.48f279b3.png";